module.exports = __webpack_public_path__ + "media/images/responsive/flow/yoso_step03-ae52cfd9a3c6d6336eb3f212d3b17f51.jpg";